export const IndustriesPageText = {
  "_1": "Toepassingen",
  "_2": "Luchtkwaliteit is een hot topic, relevant in veel sectoren. aircheckr verandert luchtkwaliteitsinformatie in iets positiefs. Door aircheckr te integreren, stel je je klanten in staat om direct of indirect betere beslissingen te nemen en acties te ondernemen om betere lucht in te ademen."
};


export const IndustriesText = {
  "homeandoffice": {
    "title": "Huis en Kantoor",
    "quote": "Luchtvervuiling binnenshuis heeft aanzienlijke gevolgen voor de gezondheid en wordt sterk beïnvloed door de luchtvervuiling buitenshuis.",
    "author": "Royal College of Physicians, 2016"
  },
  "auto": {
    "title": "Automobiel",
    "quote": "Concentraties aan specifieke verontreinigende stoffen kunnen tot 10 keer hoger zijn in voertuigen dan langs de weg.",
    "author": "Berkley Wellness, 2016 "
  },
  "health": {
    "title": "Digitale gezondheid",
    "quote": "6,5 miljoen mensen worden jaarlijks ziek in de EU, omdat luchtvervuiling ziektes/aandoeningen veroorzaakt zoals beroertes, astma en bronchitis.",
    "author": "Europees Milieu Agentschap, 2014"
  },
  "info": {
    "title": "Informatief",
    "quote": "Het is belangrijk om 'digital signage' of de inhoud van sites up-to-date te houden. Informatie over luchtkwaliteit is ideaal omdat deze regelmatig verandert in de tijd en in de ruimte.",
    "author": "Dynamax"
  },
  "outdoor": {
    "title": "Outdoor",
    "quote": "Wanneer we sport beoefenen, kan het volume aan lucht dat door de longen wordt gepompt acht keer hoger zijn dan tijdens rust.",
    "author": "The European Lung Foundation"
  },
  "intelli": {
    "title": "Intelligence",
    "quote": "Het aantal vroegtijdige sterfgevallen als gevolg van luchtvervuiling is in de EU meer dan tien keer het aantal te wijten aan verkeersongelukken.",
    "author": "Europees Milieu Agentschap, 2014"
  }
};

export default IndustriesPageText;



// WEBPACK FOOTER //
// ./src/input-text/nl/industries_page.js